import { useEffect } from "react";
import Routes from "routes";

import { configure } from "axios-hooks";

import Locales from "components/locales";
import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "components/rtlLayout";
import Snackbar from "components/snackbar";
import ThemeCustomization from "themes";
import PusherNotification from "features/components/pusherNotification";
import BusinessBranches from "features/components/businessBranches";
import { updateMetaTags } from "features/components/helperFunctions";
import FirebaseRemoteConfig from "services/firebaseRemoteConfig";
import FireStoreConfig from "services/fireStore";
import axios from "utils/axios";

import { useSelector } from "store";
import { useClarity } from "hooks/useClarity";

configure({ axios });

// ==============================|| APP ||============================== //

const App = () => {
  const {
    firebaseDetails: { clarity },
  } = useSelector((reduxState) => reduxState.firebaseDetails);

  // ==============================|| custom hooks ||============================== //

  // custom hook to initialize clarity
  const { initializeClarity } = useClarity();

  // ==============================|| useEffect hook ||============================== //

  useEffect(() => {
    // function to update the meta tags for tossdown or ordrz
    updateMetaTags();
  }, []);

  useEffect(() => {
    // verify clarity status and project id (from firebase) before initializing
    if (clarity?.status && clarity?.projectId) {
      // function to initialize clarity
      initializeClarity(clarity);
    }
  }, [clarity]);

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <NavigationScroll>
            <>
              <FireStoreConfig />
              <FirebaseRemoteConfig />
              <BusinessBranches />
              <Routes />
              <Snackbar />
              <PusherNotification />
            </>
          </NavigationScroll>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
